export function getWeddingOnboardingInitialState() {
	return {
		role: '',
		kazooName: '',
		startDate: null,
		endDate: null,
		multiDay: false,
		type: '',
		plannerSupport: '',
		budget: undefined,
		guestCount: 100,
		guestTravelingAfar: '',
		colorScheme: [],
		theme: '',
		ceremonyVenue: '',
		ceremonyEnvision: [],
		ceremonyVibe: [],
		reception: true,
		receptionVenue: '',
		receptionEnvision: [],
		receptionVibe: [],
		dinnerStyle: '',
		foodType: [],
		culturalSignificances: [],
		traditions: [],
		receptionActivities: [],
		captureCount: {
			photography: 0,
			videography: 0,
			contentCreation: 0,
			photobooth: 0,
		},
		specialActivities: [],
		music: '',
		invitationShareMethod: '',
	}
}
